import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m6.429 9.752-4.179 2.25 4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.502 12 2.252l9.75 5.25-4.179 2.25m0 0 4.179 2.25-4.179 2.25m0 0 4.179 2.25-9.75 5.25-9.75-5.25 4.179-2.25m11.142 0-5.571 3-5.571-3"
    }, null, -1)
  ])))
}
export default { render: render }